import * as React from 'react'
import * as classNames from 'classnames'
import {
  ITripRequestObject,
  ITripAvailableProduct,
  ITripEstimatesObject,
  IAddOn,
  ITripExtraParams,
  SelectedAddOn,
  IServicePricingType,
  IRiderObject
} from '../../../types'
import { secondsToMinutes, convertCentsToDollars } from '../../../utils'
import ImageView from '../../ui/ImageView'
import Star from '../../icons/ui/Star'
import * as moment from 'moment'
import { MoonLoader } from 'react-spinners'
import { tripAvailableProductsInitValue } from 'src/constants/trip'
import ToolTip from 'src/components/ui/ToolTip'
import Exclamation from 'src/components/icons/ui/Exclamation'
import AssignTripPassenger from '../AssignTripPassenger'
import { RouteComponentProps } from 'react-router'
import { serviceEntityService } from 'src/services/Service'
import { isEqual } from 'lodash'
import { Input } from '@mobiscroll/react-latest'
import UpdatedTooltip from 'src/components/ui/UpdatedTooltip'

enum CONSTRAINTS {
  UNAVAILABLE = 1,
  INSUFFICIENT_FUNDS = 2,
  MEMBERSHIP_REQUIRED = 3
}

const CONSTRAINTS_LABEL = {
  [`${CONSTRAINTS.UNAVAILABLE}`]: 'Unavailable',
  [`${CONSTRAINTS.INSUFFICIENT_FUNDS}`]: 'Low Funds',
  [`${CONSTRAINTS.MEMBERSHIP_REQUIRED}`]: 'Membership Required'
}

const multipleStopErrMsg =
  'Multiple Stop is disabled on this service. Please delete the multiple stop location or enable Multiple Stop on service settings.'

export interface AddOnsType {
  [key: string]: number
}
export interface ITripServiceProductListProps extends RouteComponentProps<{ riderId: string }> {
  bookDoubleTrip: boolean
  currentServiceId: string
  fetching: boolean
  pricingType: IServicePricingType[]
  products: ITripAvailableProduct[]
  rider: IRiderObject
  riderId?: string
  selectedProductId: string | null
  tripRequest: ITripRequestObject
  walletBalance: number
  createRecurringTrip: () => void
  createTripErrorMessage: (message: string) => void
  createTrip: () => Promise<void>
  fetchIntegrationEta: (
    riderId: string,
    product: ITripAvailableProduct,
    addOn?: SelectedAddOn
  ) => Promise<ITripAvailableProduct>
  fetchServicePricingType: (serviceId: string) => void
  selectEstimates: (estimates: ITripEstimatesObject) => Promise<any>
  selectProduct: (product: ITripAvailableProduct) => void
  selectRider: (rider: any) => void
  setCurrentServiceId: (serviceId: string) => void
  setTripDoubleCheckerEnable: (enable: boolean) => void
  setTripRequestTotalRidersFare: (totalRidersFare: number) => void
  updatePaymentMode: (paymentMode: string) => void
  updateRiderCount: (totalRider: number) => void
  updateTripNotes: (notes: string) => void
}
export interface ITripServiceProductListState {
  products: ITripAvailableProduct[]
}
export default class TripServiceProductList extends React.Component<ITripServiceProductListProps> {
  public state = {
    products: [tripAvailableProductsInitValue]
  }
  public componentDidMount() {
    this.setState({
      products: this.props.products
    })
    this.props.setTripDoubleCheckerEnable(true)
    this.props.updatePaymentMode('Wallet')
  }
  public componentDidUpdate(prevProps: ITripServiceProductListProps) {
    if (prevProps.products !== this.props.products) {
      this.setState({
        products: this.props.products
      })
    }
  }
  public render() {
    // const { products } = this.props
    const { products } = this.state
    return (
      <div>
        {products
          .filter(item => item.name !== 'noProduct')
          .map(p => {
            return <TripServiceProductListItem key={`trip-service-product-${p.id}`} product={p} {...this.props} />
          })}
      </div>
    )
  }
}

export interface ITripServiceProductListItemProps extends RouteComponentProps<{ riderId: string }> {
  bookDoubleTrip: boolean
  currentServiceId: string
  fetching: boolean
  pricingType: IServicePricingType[]
  product: ITripAvailableProduct
  rider: IRiderObject
  riderId?: string
  selectedProductId: string | null
  tripRequest: ITripRequestObject
  walletBalance: number
  createRecurringTrip: () => void
  createTrip: (product: ITripAvailableProduct, params: ITripExtraParams) => Promise<void>
  createTripErrorMessage: (message: string) => void
  fetchIntegrationEta: (
    riderId: string,
    product: ITripAvailableProduct,
    addOn?: SelectedAddOn
  ) => Promise<ITripAvailableProduct>
  fetchServicePricingType: (serviceId: string) => void
  selectEstimates: (estimates: ITripEstimatesObject) => Promise<any>
  selectProduct: (product: ITripAvailableProduct) => void
  selectRider: (rider: any) => void
  setCurrentServiceId: (serviceId: string) => void
  setTripDoubleCheckerEnable: (enable: boolean) => void
  setTripRequestTotalRidersFare: (totalRidersFare: number) => void
  updatePaymentMode: (paymentMode: string) => void
  updateRiderCount: (totalRider: number) => void
  updateTripNotes: (notes: string) => void
}

export interface ITripServiceProductListItemState {
  totalFare: number
  addOn: { [key: string]: number }
  addOnCost: number
  addOnFare: number
  addOnOtherLabel: string
  addOnOtherPrice: number
  addOnTotalAmount: number
  bookDoubleTrip: boolean
  checkedmanual: boolean
  constraint: number
  enableButtonLowFunds: boolean
  eta: string
  isDisplayAddOns: boolean
  isOpen: boolean
  isOtherPriceSelected: boolean
  notesManual: string
  origNotes: string
  otherLabelDisabled: boolean
  otherPriceDisabled: boolean
  requesting: boolean
  showButtonManual: boolean
  showText: boolean
}
class TripServiceProductListItem extends React.Component<
  ITripServiceProductListItemProps,
  ITripServiceProductListItemState
> {
  public static getDerivedStateFromProps(
    nextProps: ITripServiceProductListItemProps,
    prevState: ITripServiceProductListItemState
  ) {
    const stateObj: any = {}

    const { product, walletBalance } = nextProps

    if (product && product.serviceMembershipRequired && !product.riderHasMembership) {
      stateObj.constraint = CONSTRAINTS.MEMBERSHIP_REQUIRED
    } else if ((product && product.unavailable) || !product) {
      stateObj.constraint = CONSTRAINTS.UNAVAILABLE
      stateObj.open = false
    } else {
      const customerFare = convertCentsToDollars(product.fare)

      if (walletBalance < customerFare) {
        stateObj.constraint = CONSTRAINTS.INSUFFICIENT_FUNDS
        stateObj.open = false
      } else {
        stateObj.constraint = 0
      }
    }

    return stateObj
  }

  public static findAvailability(rawData: any[]) {
    // Generate Week list
    const generateWeekDates = () => {
      const weekDates = []
      for (let i = 0; i < 7; i++) {
        const date = moment()
          .add(i, 'day')
          .format('YYYY-MM-DD')
        weekDates.push({
          date,
          day: moment(date)
            .format('ddd')
            .toLowerCase(),
          available: true
        })
      }
      return weekDates
    }

    // Main Logic
    const checkAvailability = (uniqueWeekDays: string[], uniqueHolidayDates: string[]) => {
      const weekDateList = generateWeekDates()
      for (const date of weekDateList) {
        if (uniqueHolidayDates.includes(date.date) || !uniqueWeekDays.includes(date.day)) {
          date.available = !date.available
        }
      }
      return weekDateList
    }

    const weekDays: string[] = []
    const holidayList: string[] = []

    // Filter Data
    rawData.filter(r => {
      r.serviceDaysHours_days.filter((day: string) => {
        weekDays.push(day)
      })
      holidayList.push(moment(r.serviceHolidays_date).format('YYYY-MM-DD'))
    })

    // Make unique instance
    const unique = (value: string, index: number, self: any) => {
      return self.indexOf(value) === index
    }

    // Make array Unique
    const uniqueWeekDays = weekDays.filter(unique)
    const uniqueHolidayDates = holidayList.filter(unique)

    // Call main logic
    return checkAvailability(uniqueWeekDays, uniqueHolidayDates)
  }

  public static checkUnavailableReason(unavailableReason: string) {
    const isJson = unavailableReason.includes('{') ? true : false
    const result = isJson ? TripServiceProductListItem.findAvailability(JSON.parse(unavailableReason)) : []
    return { isJson, result }
  }

  public state = {
    totalFare: 0,
    addOn: {},
    addOnCost: 0,
    addOnFare: 0,
    addOnOtherLabel: 'Other',
    addOnOtherPrice: 0,
    addOnTotalAmount: 0,
    bookDoubleTrip: false,
    checkedmanual: false,
    constraint: 0,
    enableButtonLowFunds: false,
    eta: '',
    isDisplayAddOns: false,
    isOpen: true,
    isOtherPriceSelected: false,
    notesManual: 'Collect',
    origNotes: this.props.tripRequest.notes ? this.props.tripRequest.notes : '',
    otherLabelDisabled: false,
    otherPriceDisabled: false,
    requesting: false,
    //use this state to enable and disbale services with manual fare collection
    showButtonManual: false,
    showText: false,
    willCall: false,
    scheduledReturn: false,
    returnPickupTime: ''
  }
  public componentDidMount() {
    if (this.props.product.eta !== 0) {
      this.setState({
        eta: secondsToMinutes(this.props.product.eta)
      })
    }
  }
  public componentDidUpdate(prevProps: ITripServiceProductListItemProps, prevState: ITripServiceProductListItemState) {
    if (prevProps.fetching !== this.props.fetching) {
      this.setState({
        requesting: this.props.fetching
      })
    }
    if (prevProps.bookDoubleTrip !== this.props.bookDoubleTrip) {
      this.setState({
        bookDoubleTrip: this.props.bookDoubleTrip
      })
    }

    if (!isEqual(prevState.addOn, this.state.addOn)) {
      ;(async () => {
        await this.fetchSpecificProductWithAddOn(this.state.addOn)
      })()
    }
  }
  public render() {
    const { product, selectedProductId, tripRequest, walletBalance } = this.props
    const isActive = product.id === selectedProductId
    const activeClass = classNames({ 'trip-provider-list--active': isActive })
    const { constraint, requesting, addOnCost, addOnFare, addOn } = this.state
    let etaText = ''
    let availabilityService: any[] = []
    // 1min default waiting time to those ondemand trips with zero eta
    const onDemandDefaultEta = 60

    if (constraint) {
      const { isJson, result } = TripServiceProductListItem.checkUnavailableReason(product.unavailableReason)
      availabilityService = result

      etaText = constraint === CONSTRAINTS.UNAVAILABLE ? product.unavailableReason : CONSTRAINTS_LABEL[constraint]
      etaText = isJson ? CONSTRAINTS_LABEL[constraint] : etaText
    } else if (this.state.eta !== '') {
      etaText = this.state.eta
      //Stupid hack, just like everything to do with Lyft
    } else if (product && product.name === 'Lyft') {
      etaText = 'N/A'
    } else if (product && product.eta) {
      etaText = secondsToMinutes(product.eta)
    } else if (product && product.integrationId && product.integrationId.length > 0) {
      etaText = 'Select for ETA'
    } else if (product && !product.eta) {
      etaText = this.isOndemand(tripRequest.scheduledPickupTime)
        ? secondsToMinutes(onDemandDefaultEta)
        : 'Scheduled time'
    }
    const customerFare = convertCentsToDollars(product.fare)
    const cost = this.calculateTotalCostAndfare(addOnCost, addOnFare, addOn).price
    const fare = this.calculateTotalCostAndfare(addOnCost, addOnFare, addOn).fare

    const inputIdOther = `${product.serviceName}-${product.name}-add-on-other`.split(' ').join('_')
    const keyNameOther = `${product.serviceName}-${product.name}-add-on-key`.split(' ').join('_')
    const addOnOtherPriceDisplay = this.state.addOnOtherPrice / 100
    const tripRequestRider = this.props.tripRequest.passengerDetails.tripRequestRiders[0]
    const hasFareType = tripRequestRider !== undefined ? tripRequestRider.fareType : null

    return (
      <div className={`py1 px2 pt1 flex flex-wrap items-start cursor--pointer ${activeClass}`}>
        <div className='tspl-image-view-wrapper flex flex-wrap col-12'>
          <div className='tspl-product-wrapper flex items-center col-12 mt1' onClick={this.selectProduct(product)}>
            <ImageView entityId={product.id} width='20px' height='20px' />
            <span className='font-dark-grey h6 ml1 weight-500 tspl-product-name text-start'>{product.name}</span>
            {etaText !== 'no drivers' && (
              <span
                className={classNames({
                  'font-dark-grey h6 weight-300 ml-auto': !constraint,
                  'font-white bg-red rounded uppercase ml-auto tspl-constraint': constraint
                })}
              >
                {etaText}
              </span>
            )}
          </div>
          {isActive && !hasFareType && product.serviceId === this.props.currentServiceId && (
            <div>
              <div className='col-12 py1 font-red mx-auto mt1 mb1'>
                Payment method of this selected service should not be empty.
              </div>
            </div>
          )}
          {/* displays rider details edit section*/}
          {isActive && hasFareType && (
            <div className='flex justify-between items-center mt1'>
              <label className='h6' htmlFor='rider-count'>
                Riders:{' '}
              </label>
              <div className='tspl-assign-trip-link-wrapper flex align-center h6 mr2'>
                <span className='weight-500 bold h6 ml1 mr1'> {this.props.tripRequest.additionalRiders}</span>
                <span className='weight-500 bold ml1 mr1'>
                  <AssignTripPassenger actionUrl={`${this.props.match.url}`} />
                </span>
              </div>
            </div>
          )}
          {/* enable collect fare button */}
          {hasFareType && (
            <div className='flex col-6 ml-auto justify-end items-center'>
              {walletBalance < customerFare && etaText !== 'OUT OF SERVICE ZONE' && (
                <div className='h6 flex items-center' style={{ whiteSpace: 'nowrap' }}>
                  <input
                    defaultChecked={this.state.checkedmanual}
                    className=''
                    type='checkbox'
                    id='chkCashManual'
                    onClick={this.setManualCash}
                  />
                  {'COA '}
                  <UpdatedTooltip text={'Collect Fare on Arrival'}>
                    <Exclamation className='icon--small' style={{ marginTop: '3px', marginLeft: '4px' }} />
                  </UpdatedTooltip>
                </div>
              )}
            </div>
          )}
          {/* enable collect fare button */}
          {product && (
            <div className='flex col-12 pt1 pb1 ml-auto right-align'>
              {this.renderAvailabilityText(product)}
              {!isNaN(product.price) && this.state.showText === true && (
                <span className='font-grey2 h6 weight-500 ml2'>{`cost: $${convertCentsToDollars(cost)}`}</span>
              )}
              {!isNaN(product.fare) && this.state.showText === true && (
                <span className='font-grey2 h6 weight-500 ml2'>{`fare: $${convertCentsToDollars(fare)}`}</span>
              )}
            </div>
          )}
        </div>

        {isActive &&
          hasFareType &&
          this.state.isDisplayAddOns &&
          product.addOn &&
          //Comment Add on Validation
          // (walletBalance >= customerFare || this.state.enableButtonLowFunds === true) &&
          product.addOn.map((item: IAddOn) => {
            const inputId = `${product.serviceName}-${product.name}-add-on-${item.label}`.split(' ').join('_')
            const price = item.price / 100
            return (
              <div className='flex col-12 justify-start font-grey3 h6 mt03 items-center' key={item.label}>
                <input
                  id={inputId}
                  checked={this.state.addOn[item.label] >= 0}
                  name={item.label}
                  type='checkbox'
                  onChange={() => this.addOnCost(inputId, item.label, item.price, product.fare)}
                />
                <label className='h6'>
                  {item.label} ${price.toFixed(2)}
                </label>
              </div>
            )
          })}

        {isActive && hasFareType && this.state.isDisplayAddOns && product.addOn && product.addOn.length > 0 && (
          //Comment Add on Validation
          // (walletBalance >= customerFare || this.state.enableButtonLowFunds === true) &&
          <div
            className='flex col-12 justify-start font-grey3 h6 mt03 items-center'
            id={inputIdOther}
            key={keyNameOther}
          >
            <input
              name={keyNameOther}
              checked={this.state.isOtherPriceSelected}
              type='checkbox'
              onChange={() =>
                this.addOnOtherCost(inputIdOther, this.state.addOnOtherLabel, this.state.addOnOtherPrice, product.fare)
              }
            />
            {this.state.otherPriceDisabled ? (
              <label className='h6' htmlFor='addOnLabel-Other'>
                {this.state.addOnOtherLabel} ${addOnOtherPriceDisplay.toFixed(2)}
              </label>
            ) : (
              <div className='flex flex-row items-center'>
                <Input
                  name={'addOnLabel-Other'}
                  type='text'
                  value={this.state.addOnOtherLabel}
                  disabled={this.state.otherLabelDisabled}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.setAddOnOtherLabel(e.target.value)}
                  style={{ height: '28px', width: '120px', marginRight: '8px', fontSize: '12px', marginLeft: '2px' }}
                  placeholder={'Add On (e.g. Other Charge)'}
                  theme='ios'
                  themeVariant='light'
                  inputStyle='box'
                  labelStyle='floating'
                />
                <Input
                  name={'addOnPrice-Other'}
                  type='number'
                  disabled={this.state.otherPriceDisabled}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    this.setAddOnOtherPrice(inputIdOther, e.target.value)
                  }
                  style={{ height: '28px', width: '80px', fontSize: '12px' }}
                  className='mobiscroll-input form'
                  placeholder={'Price'}
                  theme='ios'
                  themeVariant='light'
                  inputStyle='box'
                  labelStyle='floating'
                />
              </div>
            )}
          </div>
        )}

        {isActive &&
        hasFareType &&
        this.state.bookDoubleTrip === false &&
        this.state.showButtonManual === true &&
        product.serviceId === this.props.currentServiceId &&
        !requesting && //do not display if requestiong for recurring trip
          (!tripRequest.recurringPickupTime && !tripRequest.recurringDropoffTime) &&
          (product.completedTripCount < product.serviceTripLimit || product.serviceTripLimit === 0) &&
          walletBalance >= customerFare &&
          product.unavailable === false &&
          product.riderHasMembership === true && (
            <>
              <div className='col-5 py1 bg-green center font-white mx-auto mt1 rounded' onClick={this.createTrip}>
                Request
              </div>
              <div className='col-1' />
              <div className='col-6 ml1 py1 bg-green center font-white mx-auto mt1 rounded' onClick={this.createTrip}>
                Collect Fare
              </div>
            </>
          )}

        {isActive &&
        hasFareType &&
        this.state.bookDoubleTrip === false &&
        this.state.showButtonManual === true &&
        product.serviceId === this.props.currentServiceId &&
        !requesting && //do not display if requestiong for recurring trip
        (!tripRequest.recurringPickupTime && !tripRequest.recurringDropoffTime) &&
        (product.completedTripCount < product.serviceTripLimit || product.serviceTripLimit === 0) &&
        walletBalance >= customerFare &&
        product.unavailableReason === 'no drivers' && //Create trip even if there's no driver
          product.riderHasMembership === true && (
            <>
              <div className='col-5 py1 bg-green center font-white mx-auto mt1 rounded' onClick={this.createTrip}>
                Request
              </div>
              <div className='col-1' />
              <div className='col-6 ml1 py1 bg-green center font-white mx-auto mt1 rounded' onClick={this.createTrip}>
                Collect Fare
              </div>
            </>
          )}

        {isActive &&
        hasFareType &&
        this.state.bookDoubleTrip === false &&
        this.state.showButtonManual === false &&
        product.serviceId === this.props.currentServiceId &&
        !requesting && //do not display if requestiong for recurring trip
          (!tripRequest.recurringPickupTime && !tripRequest.recurringDropoffTime) &&
          (product.completedTripCount < product.serviceTripLimit || product.serviceTripLimit === 0) &&
          walletBalance >= customerFare &&
          product.unavailable === false &&
          product.riderHasMembership === true && (
            <div className='col-12 py1 bg-green center font-white mx-auto mt1 rounded' onClick={this.createTrip}>
              Request
            </div>
          )}

        {isActive &&
        hasFareType &&
        this.state.bookDoubleTrip === false &&
        this.state.showButtonManual === false &&
        product.serviceId === this.props.currentServiceId &&
        !requesting && //do not display if requestiong for recurring trip
        (!tripRequest.recurringPickupTime && !tripRequest.recurringDropoffTime) &&
        (product.completedTripCount < product.serviceTripLimit || product.serviceTripLimit === 0) &&
        walletBalance >= customerFare &&
        product.unavailableReason === 'no drivers' && //Create trip even if there's no driver
          product.riderHasMembership === true && (
            <div className='col-12 py1 bg-green center font-white mx-auto mt1 rounded' onClick={this.createTrip}>
              Request
            </div>
          )}

        {isActive && hasFareType && this.state.bookDoubleTrip && (
          <div>
            <div className='col-12 py1 font-grey mx-auto mt1 mb1'>You have booked an identical trip 3 minutes ago.</div>
            <div className='col-12 py1 bg-green center font-white mx-auto mt1 rounded' onClick={this.bookDoubleTrip}>
              Confirm Another Request
            </div>
          </div>
        )}

        {/*  {(isActive &&
        product.serviceId === this.props.currentServiceId &&
        !requesting && //do not display if requestiong for recurring trip
          (!tripRequest.recurringPickupTime && !tripRequest.recurringDropoffTime) &&
          walletBalance < customerFare) ||
          (!product.riderHasMembership === false && (
            <div className='col-12 py1 center font-white mx-auto mt1 rounded red-font' />
          ))} */}

        {isActive && hasFareType && this.state.enableButtonLowFunds && walletBalance < customerFare && (
          <div className='col-12 mx-auto mt1 rounded py1' style={{ color: 'black' }} />
        )}

        {isActive &&
        hasFareType &&
        this.state.bookDoubleTrip === false &&
        this.state.enableButtonLowFunds === true &&
        product.serviceId === this.props.currentServiceId &&
        !requesting && //do not display if requestiong for recurring trip
          (!tripRequest.recurringPickupTime && !tripRequest.recurringDropoffTime) &&
          (product.completedTripCount < product.serviceTripLimit || product.serviceTripLimit === 0) &&
          walletBalance < customerFare &&
          product.unavailable === false &&
          product.riderHasMembership === true && (
            <div className='col-12 py1 bg-green center font-white mx-auto rounded' onClick={this.createTrip}>
              Collect Fare
            </div>
          )}

        {isActive &&
        hasFareType &&
        this.state.bookDoubleTrip === false &&
        this.state.enableButtonLowFunds === true &&
        product.serviceId === this.props.currentServiceId &&
        !requesting && //do not display if requestiong for recurring trip
          (!tripRequest.recurringPickupTime && !tripRequest.recurringDropoffTime) &&
          (product.completedTripCount < product.serviceTripLimit || product.serviceTripLimit === 0) &&
          walletBalance < customerFare &&
          product.unavailableReason === 'no drivers' &&
          product.riderHasMembership === true && (
            <div className='col-12 py1 bg-green center font-white mx-auto rounded' onClick={this.createTrip}>
              Collect Fare
            </div>
          )}

        {isActive &&
        hasFareType &&
        product &&
        !requesting && //do not display if requestiong for recurring trip
          (!tripRequest.recurringPickupTime && !tripRequest.recurringDropoffTime) &&
          product.completedTripCount > 0 &&
          product.completedTripCount === product.serviceTripLimit && (
            <div className='col-12 py1 center font-white mx-auto mt1 rounded red-font' onClick={this.error}>
              You have reached the trip limit for this service.
            </div>
          )}

        {walletBalance >= customerFare && // display button if balance is greater than or equal the fare
        isActive &&
        product.serviceId === this.props.currentServiceId &&
        !requesting && //display if requestiong for recurring trip
          (tripRequest.recurringPickupTime || tripRequest.recurringDropoffTime) &&
          tripRequest.crontabExp !== undefined &&
          tripRequest.timesToRecur !== undefined &&
          tripRequest.runForever !== undefined && (
            <div
              className='col-12 py1 bg-green center font-white mx-auto mt1 rounded'
              onClick={this.createRecurringTrip}
            >
              Recur Request
            </div>
          )}

        {isActive &&
        hasFareType &&
        product.serviceId === this.props.currentServiceId &&
        this.state.enableButtonLowFunds === true &&
        !requesting && //display if requestiong for recurring trip
          (tripRequest.recurringPickupTime || tripRequest.recurringDropoffTime) &&
          tripRequest.crontabExp !== undefined &&
          tripRequest.timesToRecur !== undefined &&
          tripRequest.runForever !== undefined && (
            <div
              className='col-12 py1 bg-green center font-white mx-auto mt1 rounded'
              onClick={this.createRecurringTrip}
            >
              Recur Request
            </div>
          )}
        {isActive &&
          product.serviceId === this.props.currentServiceId &&
          requesting === true &&
          !this.state.bookDoubleTrip && <MoonLoader sizeUnit={'px'} size={20} color={'#405264'} loading={true} />}
      </div>
    )
  }

  private renderAvailabilityText = (ap: ITripAvailableProduct) => {
    const { busyDrivers, availableDrivers } = ap

    if (typeof busyDrivers !== 'number' || typeof availableDrivers !== 'number') {
      return <span className='ml-auto' />
    }

    if (busyDrivers > availableDrivers) {
      return <span className='font-red bold h6 uppercase ml-auto'>busy</span>
    }

    if (availableDrivers) {
      return <span className='font-grey2 h6 weight-500 ml-auto'>{ap.availableDrivers} available</span>
    }

    return <span className='ml-auto' />
  }
  private setManualCash = () => {
    const { product, selectedProductId } = this.props
    const isActive = product.id === selectedProductId
    const getNotes =
      this.props.tripRequest.notes +
      ' ' +
      this.state.notesManual +
      ' ' +
      `$${convertCentsToDollars(product.fare + this.state.addOnFare)}` //+ ' ' + this.props.tripRequest.paymentMode
    const originalNotes = this.state.origNotes
    const PmodeValue = 'Cash'
    const PmodeDefaultValue = 'Wallet'

    const isProductRendered = isActive && this.state.isDisplayAddOns && product.addOn
    // if products are not yet rendered, fetch integration products
    if (!!!isProductRendered) {
      this.selectProduct(product)()
    }

    this.setState({
      enableButtonLowFunds: !this.state.enableButtonLowFunds
    })

    if (this.state.enableButtonLowFunds === false) {
      //Clear PaymentMode First
      this.props.updatePaymentMode(PmodeDefaultValue)
      //This function will print cash value
      this.props.updatePaymentMode(PmodeValue)
      //Update the Notes with FARE
      // this.props.updateTripNotes(getNotes)
    } else {
      //Clear PaymentMode First
      this.props.updatePaymentMode(PmodeDefaultValue)
      this.props.updateTripNotes(originalNotes)
    }
  }

  private selectProduct = (product: ITripAvailableProduct) => {
    //for manual fare function
    const { walletBalance } = this.props
    const customerFare = convertCentsToDollars(product.fare)

    return async () => {
      this.setState({
        showText: true,
        checkedmanual: false,
        addOn: {},
        isOtherPriceSelected: false
        // enableButtonLowFunds: this.state.enableButtonLowFunds
      })
      // if (this.state.constraint || !product || this.props.product.unavailable) {
      //   return
      // }

      //Clickable products wether low funds or not
      if (!product) {
        return
      }

      /* This area will be used to set notes */
      /* if (walletBalance < customerFare) {
         alert("CASH WOULD BE COLLECTED ON PICKUP");
       }
       else {
         alert("Same Notes!");
       } */

      const { integrationId } = this.props.product
      let { price, fare, eta } = this.props.product
      this.props.selectProduct(product)
      this.props.setCurrentServiceId(this.props.product.serviceId)

      // if (this.props.riderId && integrationId && integrationId.length > 0) {
      if (this.props.riderId) {
        const fetchedProduct = await this.props.fetchIntegrationEta(this.props.riderId, product)
        price = fetchedProduct.price
        fare = fetchedProduct.fare
        eta = fetchedProduct.eta
        this.props.selectProduct(fetchedProduct)
        if (this.props.pricingType.length > 0) {
          this.setRidersTotalFare()
          this.getTotalRiders()
        }
      }

      try {
        this.props.selectEstimates({ price: Math.round(price), fare: Math.round(fare), eta: Math.round(eta) })

        this.displayProductAddOns()
      } catch (e) {
        console.log('Error saving estimates to trip request: ', e)
      }
    }
  }
  private setRidersTotalFare = () => {
    const { pricingType, tripRequest } = this.props
    const totalFares = tripRequest.passengerDetails.tripRequestRiders.reduce((partialSum, rider) => {
      const pricing = pricingType.find(priceType => priceType.riderType === rider.riderType)
      if (pricing) {
        return partialSum + pricing.fare * rider.totalRider
      }
      return partialSum
    }, 0)
    this.props.setTripRequestTotalRidersFare(totalFares)
  }
  private getTotalRiders = () => {
    const tripRequest = this.props.tripRequest
    const totalRider = tripRequest.passengerDetails.tripRequestRiders.reduce((partialSum, rider) => {
      return partialSum + rider.totalRider
    }, 0)
    this.props.updateRiderCount(totalRider)
  }
  private addOnCost = async (inputId: string, addOnLabel: string, addOnPrice: number, currentFare: number) => {
    const inputElement = document.getElementById(`${inputId}`) as HTMLInputElement

    if (inputElement) {
      const checked = inputElement.checked

      const addOns = checked === true ? { ...this.state.addOn, [addOnLabel]: addOnPrice } : this.removeAddOn(addOnLabel)

      this.setState({
        addOn: addOns
      })
    } else {
      console.log('No input element: ' + inputElement)
    }
  }

  private addOnOtherCost = async (inputId: string, addOnLabel: string, addOnPrice: number, currentFare: number) => {
    const inputElement = document.querySelectorAll(`#${inputId} input`)[0] as HTMLInputElement
    let checked = inputElement.checked

    if (addOnLabel !== '' && addOnPrice >= 0) {
      const addOns = checked === true ? { ...this.state.addOn, [addOnLabel]: addOnPrice } : this.removeAddOn(addOnLabel)

      this.setState({
        addOnOtherPrice: checked === true ? addOnPrice : 0,
        isOtherPriceSelected: checked,
        addOn: addOns
      })

      await this.fetchSpecificProductWithAddOn(addOns)
    } else {
      inputElement.checked = false
      checked = inputElement.checked
    }

    this.setState({
      otherLabelDisabled: checked ? true : false,
      otherPriceDisabled: checked ? true : false
    })
  }

  private async fetchSpecificProductWithAddOn(addOns: AddOnsType) {
    const { fare } = this.props.product

    if (this.props.riderId) {
      const fetchedProduct = await this.props.fetchIntegrationEta(this.props.riderId, this.props.product, addOns)
      const updatedFare = this.calculateFare(fare, addOns, fetchedProduct.fare)

      this.setState({
        totalFare: updatedFare
      })
      this.props.selectProduct(fetchedProduct)
    }
  }

  /**
   * Calculates fare with consideration to passengers and their fare types.
   * If an addOn is included, we recalculate the fare so the add-on fee will be added on TOP OF the total non-cash riders.
   * Otherwise, do the normal calculation.
   * @param fare The base fare
   * @param addOns The addOn fees if provided
   * @param initialFare The initial fare value
   * @returns The total fare
   */
  private calculateFare(fare: number, addOns: AddOnsType, initialFare: number) {
    const originalFare = fare
    const { nonCashRiderCount, cashRiderCount } = this.getGroupedRiderCount()
    const addedNonCashRiderCount = Math.max(nonCashRiderCount - 1, 0) // we deduct 1 here to exclude the default Adult-Wallet rider in the fetchIntegrationEta call

    const updatedFare =
      Object.values(addOns).length > 0
        ? initialFare + originalFare * addedNonCashRiderCount + originalFare * cashRiderCount // The initial fare value here includes the default Adult-wallet rider and add-on, so we just need to add the fare of other riders.
        : originalFare * (nonCashRiderCount + cashRiderCount)
    return updatedFare
  }

  /**
   * Gets the number of cash-rider and noncash-rider
   * @returns The number of cash-rider and noncash-rider
   */
  private getGroupedRiderCount(): { nonCashRiderCount: number; cashRiderCount: number } {
    const riders = this.props.tripRequest.passengerDetails.tripRequestRiders || []
    return riders.reduce(
      (counts, rider) => {
        if (rider.fareType === 'Cash') {
          counts.cashRiderCount += rider.totalRider
        } else {
          counts.nonCashRiderCount += rider.totalRider
        }
        return counts
      },
      { nonCashRiderCount: 0, cashRiderCount: 0 }
    )
  }

  private removeAddOn(addOnLabel: string) {
    const addOn = { ...this.state.addOn }
    delete addOn[addOnLabel]
    return addOn
  }

  private async validateMultiStopTripRequest() {
    const {
      currentServiceId,
      tripRequest: { additionalStop }
    } = this.props

    const serviceInfo = await serviceEntityService.fetchServiceMainInfo(currentServiceId)
    const { allowMultipleStop } = serviceInfo.services[currentServiceId] || false
    const isValid = !!additionalStop.length && !allowMultipleStop ? false : true
    if (!isValid) {
      this.props.createTripErrorMessage(multipleStopErrMsg)
    }
    return isValid
  }

  private bookDoubleTrip = async () => {
    const {
      product,
      tripRequest: { willCall, scheduledReturn, returnPickupTime },
      createTrip,
      createTripErrorMessage,
      setTripDoubleCheckerEnable
    } = this.props

    const { addOn, addOnCost, addOnFare } = this.state

    const { fare, price } = this.calculateTotalCostAndfare(addOnCost, addOnFare, addOn)

    // Validation for multiple stop settings
    const isValid = await this.validateMultiStopTripRequest()
    if (!isValid) {
      return
    }
    // End of validation for multiple stop settings

    this.setState(
      {
        requesting: true
      },
      async () => {
        createTripErrorMessage('')
        setTripDoubleCheckerEnable(false)
        createTrip(product, {
          addOnCost: price,
          addOnFare: fare,
          addOn,
          willCall,
          scheduledReturn,
          returnPickupTime
        })
      }
    )
  }

  private createTrip = async () => {
    const { addOn, addOnCost, addOnFare, requesting } = this.state
    const { fare, price } = this.calculateTotalCostAndfare(addOnCost, addOnFare, addOn)
    const {
      product,
      rider,
      tripRequest: { willCall, scheduledReturn, returnPickupTime },
      createTrip,
      createTripErrorMessage,
      selectRider
    } = this.props

    // Validation for multiple stop settings
    const isValid = await this.validateMultiStopTripRequest()
    if (!isValid || requesting) {
      return
    }
    // End of validation for multiple stop settings
    this.setState(
      {
        requesting: true
      },
      () => {
        createTripErrorMessage('')
        selectRider(rider)
        createTrip(product, {
          addOnCost: price,
          addOnFare: fare,
          addOn,
          willCall,
          scheduledReturn,
          returnPickupTime
        })
      }
    )
  }

  private calculateTotalCostAndfare(addOnCost: number, addOnFare: number, addOn: AddOnsType) {
    const riders = this.props.tripRequest.passengerDetails.tripRequestRiders || []
    // Exclude riders(e.g.PCA) with Free type for totalRiders to prevent extra charges when computing fare and costs
    const totalRiders = riders.reduce((acc, rider) => (rider.fareType !== 'Free' ? acc + rider.totalRider : acc), 0)

    const price = this.props.product.price * totalRiders + addOnCost
    const fare =
      (Object.values(addOn).length > 0 ? this.state.totalFare : this.props.product.fare * totalRiders) + addOnFare

    return { price, fare }
  }

  private error = () => {
    alert('You have reached the trip limit for this service.')
  }

  private createRecurringTrip = async () => {
    const { createRecurringTrip, createTripErrorMessage } = this.props

    // Validation for multiple stop settings
    const isValid = await this.validateMultiStopTripRequest()
    if (!isValid || this.state.requesting) {
      return
    }
    // End of validation for multiple stop settings
    this.setState(
      {
        requesting: true
      },
      () => {
        createTripErrorMessage('')
        createRecurringTrip()
      }
    )
  }

  private displayProductAddOns = () => {
    this.setState({
      isDisplayAddOns: this.props.selectedProductId === this.props.product.id,
      addOnCost: 0,
      addOnFare: 0,
      addOn: {},
      addOnOtherLabel: 'Other',
      addOnOtherPrice: 0,
      otherLabelDisabled: false,
      otherPriceDisabled: false,
      isOtherPriceSelected: false
    })
  }

  private setAddOnOtherLabel = (newLabel: string) => {
    this.setState({
      addOnOtherLabel: newLabel
    })
  }

  private setAddOnOtherPrice = (inputIdOther: string, newPrice: string) => {
    const inputElement = document.querySelectorAll(`#${inputIdOther} input`)[0] as HTMLInputElement
    const checked = inputElement.checked

    // set new value of other addon price
    this.setState({
      addOnOtherPrice: newPrice === '' ? 0 : parseFloat(newPrice) * 100
    })
  }
  private isOndemand(scheduledPickupTime: string | undefined) {
    return !scheduledPickupTime || scheduledPickupTime === ''
  }
}



// WEBPACK FOOTER //
// ./src/components/trips/services/TripServiceProductList.tsx